import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "CircleCI - sexy continuous integration for private repos",
  "description": "",
  "published": "2013-07-05T00:00:00.000Z",
  "redirect_from": ["/blog/circleci-sexy-continuous-integration-for-private-repos/swizec/6267"],
  "categories": "Continuous integration, Dwellers, Github, Heroku, Programming, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`One of the best parts of spinning up a new programming team is setting the processes up from scratch. That means fixing your past failures and, more importantly, playing with the shiny new toys.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/PI3LtjaZQRaz2ZB2GOfM",
        "alt": "CircleCI dashboard",
        "title": "CircleCI dashboard"
      }}></img></p>
    <p>{`The first thing we fixed at `}<a parentName="p" {...{
        "href": "http://dwellers.com"
      }}>{`Dwellers`}</a>{`, was setting up a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Continuous_integration",
        "title": "Continuous integration"
      }}>{`continuous integration`}</a>{` service on the very first day. I've never worked with an environment that makes sure all my tests are passing and pushes things into staging before. I tried a few years ago, but it was a bitch to set up and never worked.`}</p>
    <p>{`It sucks.`}</p>
    <p>{`Sure I run tests all the time, and have no problem deploying to a server - especially `}<a parentName="p" {...{
        "href": "http://www.heroku.com/",
        "title": "Heroku"
      }}>{`Heroku`}</a>{` where you just do a `}<inlineCode parentName="p">{`git push heroku`}</inlineCode>{`. But it's tedious and the less things you have to think about, the more brain cycles are free to solve actual problems.`}</p>
    <p>{`Initially I suggested using `}<a parentName="p" {...{
        "href": "https://travis-ci.org/"
      }}>{`TravisCI`}</a>{` but they `}<em parentName="p">{`still`}</em>{` don't support private repositories. Luckily we found `}<a parentName="p" {...{
        "href": "https://circleci.com/"
      }}>{`CircleCI`}</a>{`. It focuses exclusively on private `}<a parentName="p" {...{
        "href": "http://github.com",
        "title": "GitHub"
      }}>{`Github`}</a>{` repositories. Perfect.`}</p>
    <p>{`The more I look, the more I'm impressed by everything CircleCI does. It made pushing code even more fun.`}</p>
    <p>{`When you push to your branch it runs tests on that branch alone and tells you how you did. There's also a history of the past few pushes in the dashboard so you can see what your track record's like.`}</p>
    <p>{`Click on a specific push, will show you the run steps in real time. It's really fun to watch. But I should get over the novelty and stop yak shaving all the time.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/tu573fdfRCKQQjlrS2hz",
        "alt": "A CircleCI test run",
        "title": "A CircleCI test run"
      }}></img></p>
    <p>{`If all the tests pass and you pushed to `}<inlineCode parentName="p">{`master`}</inlineCode>{`, the code is automatically deployed to staging so the business guys can have fun clicking around. And seeing your code live, even just on a server nobody outside the office will see, only a few minutes after pushing to Github, is super rewarding.`}</p>
    <p>{`CircleCI can also notify you about the tests in a number of ways like sending you an email or being chatty on HipChat/IRC ... but that's not very interesting.`}</p>
    <p>{`My favourite feature is that Github seems to support CircleCI. Somehow. I haven't installed any plugins or anything, just connected my Github account to CircleCI, which is how you login and get access to any project you have access to on Github, and something new appeared.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/bzq7m0YxTaCLMzn39JaZ",
        "alt": "Test badges in branch list",
        "title": "Test badges in branch list"
      }}></img></p>
    <p>{`Those little icons in the branches list. That's new. I don't know how it got there, but it's dynamically updated with the status of every particular branch from CircleCI.`}</p>
    <p>{`If you're still waiting for TravisCI to support private repos, give CircleCI a shot. It's really awesome.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=553a99a5-d1b7-4c28-86e9-1bf2c0ed3a40",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      